module.exports = __webpack_public_path__ + "img/west-spring-992x550.48ad44d5.jpg";